const DatenJSON = {
	antragstyp: "",
	debug: false,
	restlog: {
		active: {},
		done: {},
	},
	meta: {
		unterschrifthaken: {value: false},
		wurdeVersandt:  {value: null},
		touched: {value:false},
		theme: "light",
		ready:false,
	},
}

export default DatenJSON;
